import { createFileRoute } from '@tanstack/react-router'
import { ModulesPage } from '@/features/modules'

export const Route = createFileRoute('/_authenticated/modules/')({
  component: ModulesPage,
})
